import core from '@/core';

export default {
  install(Vue) {
    Vue.filter('date', (date, mask) => core.utils.date.toString(date, mask));
  },
};
